import React from "react";
import PropTypes from "prop-types";
import { Popup as LeafletPopup } from "react-leaflet";

const SmallPopup = props => {
  const { institution } = props;

  return (
    <LeafletPopup autoClose={false} closeButton={false}>
      <h3 className={`${!institution.approved ? "unapproved" : ""}`}>
        {institution.name}
      </h3>
    </LeafletPopup>
  );
};

SmallPopup.propTypes = {
  institution: PropTypes.object
};

export default SmallPopup;



/** WEBPACK FOOTER **
 ** ./src/components/SmallPopup.jsx
 **/